import type { CardHooks } from "./registry";
import { makeBuff } from "../playtestEngine";

/**
 * Crimson Tempest — Light Slash Signature Move.
 *
 * Phase 2 baseline (no counter yet):
 *   - Attack: Power 4, Chain. On play, queue a +1 power buff for the
 *             NEXT attack only if that next attack has the Chain
 *             keyword (printed OR granted). Implemented via
 *             `requireKeyword: "Chain"` on the buff — the
 *             `firePendingBuffs` gate skips the buff when the keyword
 *             requirement isn't satisfied, and the buff persists until
 *             it actually fires (or round-end clears it).
 *   - Defend: Deflect 3, Reflect 2 — pure data, no hook needed.
 *
 * Special Move flag stays `true` so the card pays Focus on play.
 *
 * Buff amount lives on the buff (+1) and the keyword gate is parameterised
 * so future Chain-rider cards can reuse the primitive without an engine
 * change. The "+1 if next attack has Chain" rider is the exact use-case
 * the requireKeyword gate was added for.
 */
export const crimsonTempest: CardHooks = {
  onAttackPlay: (ctx) => ({
    queueSelfBuff: makeBuff(
      "Crimson Tempest",
      "next-attack",
      { kind: "power-bonus", amount: 1 },
      ctx.game.round,
      { requireKeyword: "Chain" },
    ),
    log: ["Crimson Tempest — +1 power to next Chain attack."],
  }),
};
